/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3N0ZXBoL0RvY3VtZW50cy9kZXYvbmVuZGkvbmVuZGktdmlzaW9uLWZyb250L3NyYy9hcHAvY29tcG9uZW50cy9zZW5kLW9yYWNsZS1jYXJ0L3NlbmQtb3JhY2xlLWNhcnQuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9zdGVwaC9Eb2N1bWVudHMvZGV2L25lbmRpL25lbmRpLXZpc2lvbi1mcm9udC9zcmMvYXBwL2NvbXBvbmVudHMvc2VuZC1vcmFjbGUtY2FydC9zZW5kLW9yYWNsZS1jYXJ0LmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/send-oracle-cart/send-oracle-cart.component.css.shim.ngstyle.ts